/* eslint-disable */
import React from "react";
import { MdFileDownload } from "react-icons/md";

const DownloadButton = ({ onClick, title = "Download", size = 20, color = "white", style = {} }) => {
  return (
    <MdFileDownload
      size={size}
      color={color}
      title={title}
      style={{ cursor: "pointer", zIndex: 10, ...style }}
      onClick={(e) => {
        e.stopPropagation();
        onClick && onClick();
      }}
    />
  );
};

export default DownloadButton;
